import React, { useCallback, useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import Modal from "../Modal"
import type { ModalContent, ModalButton } from "../Modal.types"

// react-transition-group has a TS compat issue with React 18 — cast to any
const Transition = CSSTransition as any

const VARIANT_CLASS: Record<NonNullable<ModalButton["variant"]>, string> = {
  primary: "btn-green",
  secondary: "btn-white",
  danger: "btn-red",
  info: "btn-yellow",
}

function getButtonClass(variant: ModalButton["variant"] = "primary"): string {
  return `wb-btn ${VARIANT_CLASS[variant]}`
}

export default function ModalCommonMessage() {
  const [isOpen, setIsOpen] = useState(false)
  const [content, setContent] = useState<ModalContent | null>(null)

  const close = useCallback(() => setIsOpen(false), [])

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<ModalContent>).detail
      setContent(detail)
      setIsOpen(true)
    }
    document.addEventListener("app:show-modal", handler)
    return () => document.removeEventListener("app:show-modal", handler)
  }, [])

  return (
    <Transition
      in={isOpen}
      appear
      unmountOnExit
      classNames="fade"
      timeout={300}
      onExited={() => setContent(null)}
    >
      <Modal
        title={content?.title}
        modalView="xs"
        cssModifyer="-mobile-bottom-sheet"
        onRequestClose={close}
      >
        <div className="form-content">
          {content?.content && <p className="body-r-14">{content.content}</p>}
          <div className="modal-buttons">
            {content?.buttons.map((btn, i) => (
              <button
                key={i}
                type="button"
                className={getButtonClass(btn.variant)}
                onClick={() => {
                  btn.onClick?.()
                  close()
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </Modal>
    </Transition>
  )
}
